import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { InputOrder } from '../inputmodels/inputorder.models';

const API = '/api/construction-projects/v1/cockpit-inputorders/';

@Injectable({ providedIn: 'root' })
export class InputOrderService {

  inputorder: InputOrder = new InputOrder();
  inputOrders: InputOrder[] = [];

  constructor(private apiCockpit: APISCockpit) { }

  async GetInfoInput(itm: InputItem) {
    if (typeof (itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id;
      this.inputOrders = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.inputOrders.length > 0) {
        this.inputorder = this.inputOrders[0];
      }
    }
    return this.inputorder;
  }

  async GetInfoInputByTask(itm: InputItem) {
    if (typeof (itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id + '/bytask/' + itm.taskid;
      this.inputOrders = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.inputOrders.length > 0) {
        this.inputorder = this.inputOrders[0];
      }
    }
    return this.inputorder;
  }

}
